import styled from "styled-components"

export const UploadHeaderWrapper = styled.div`
  padding-top: 30px;
`